import { createRoute } from '@tanstack/react-router';
import { Route as parent } from './site.tsx';
export const Route = createRoute({ getParentRoute: () => parent, path: 'reviews' }).lazy(() =>
  import('./site-reviews.lazy.tsx').then((module) => module.Route),
);
